// extracted by mini-css-extract-plugin
module.exports = {"container":"_3nAJ3","title":"_1P03z","description":"_8PDF_","imageWrapper":"_1FqXR","image":"_3R0gD"};